const FreeShippingBar = (cart_total_price) => {
  let messageWrapper = document.querySelector('.es-tier__message');
  let tierBar = document.querySelector('.es-tier__bar');

  if (cart_total_price < cart_freeshipping_price) {
    messageWrapper.innerHTML = cart_freeshipping_msg_before.replace('__PRICE__', `$${Math.round((cart_freeshipping_price - cart_total_price) / 100.0)}`);
    tierBar.style.width = `${cart_total_price / cart_freeshipping_price * 100}%`;
  } else {
    messageWrapper.innerHTML = cart_freeshipping_msg_after;
    tierBar.style.width = '100%';
  }
}

const updateCartlineCount = (count) => {
  document.querySelector('.item--count').innerHTML = count;
}

document.addEventListener('cart:updated', (event) => {
  FreeShippingBar(event.detail.cart.total_price);
  updateCartlineCount(event.detail.cart.item_count);
});

document.addEventListener("DOMContentLoaded", () => {
  FreeShippingBar(default_cart.total_price);
})

